export default class FlashService {
  constructor( $timeout, $interval, $q ) {
    'ngInject';
    this.$timeout = $timeout;
    this.$interval = $interval;
    this.$q = $q;

    this.duration = 6000;
  }

  error(message, duration = undefined){
    let dfd = this.$q.defer();
    
    this.display(message, "error", duration).then( () => dfd.resolve() );

    return dfd.promise;
  }

  success(message, duration = undefined){
    let dfd = this.$q.defer();

    this.display(message, "success", duration).then( () => dfd.resolve() );

    return dfd.promise;
  }

  warning(message, duration = undefined){
    let dfd = this.$q.defer();

    this.display(message, "warning", duration).then( () => dfd.resolve() );

    return dfd.promise;
  }

  display(message, alertClass, duration = this.duration){
    let dfd = this.$q.defer();

    let flash = $( `<div class="${ alertClass }">${ message }</div>` );
    $( '#alert-flyover' ).append( flash );

    let xPosOriginal = flash.position().left;
    let visible = 'in';
    let closeBtn = '';
    duration = Number( duration );

    // Give the element a moment offscreen
    // before telling it to come onscreen.
    // Necessary for the animation to work.
    this.$timeout( () => flash.addClass( visible ) );

    // Give the element some time onscreen
    // before telling it to go offscreen...
    let remove = ( viaBtn = false ) => {
      if ( viaBtn ) {
        duration = 0;
        closeBtn.remove();
      }

      this.$timeout( () => flash.removeClass( visible ), duration ).then( () => {
        // ...then remove it from the DOM
        // once it's completely offscreen.
        let xPosCheck = this.$interval( () => {
          if ( flash.position().left >= xPosOriginal ) {
            flash.remove();
            this.$interval.cancel( xPosCheck );
            dfd.resolve();
          }
        }, 50 );
      } );
    }

    if ( duration === -1 ) { // The message must be closed manually.
      closeBtn = $( '<div class="close">x</div>' ).click( () => remove( true ) );
      flash.append( closeBtn );
      return dfd.promise;
    } else if ( duration < 0 || isNaN( duration ) ) {
      duration = 3500;
    }

    remove();

    return dfd.promise;
  }
}
